/*
 * @Author: DaLong Li
 * @Date: 2025-02-19 19:15:10
 * @LastEditTime: 2025-02-21 09:27:37
 * @LastEditors: DaLong Li
 * @Description: 
 * 生命在于运动，代码在于抽动。
 */
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import Antd from 'ant-design-vue';
// import 'ant-design-vue/dist/antd.css';
import 'ant-design-vue/dist/reset.css';

import i18n from './i18n';

const app = createApp(App);
app.use(router);
app.use(Antd);
app.use(i18n);
app.mount('#app');
